import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Fab,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { Add } from "@mui/icons-material";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import { currencyFormat } from "../../../components/NewDetail/calculations/utils";
import CreateNewWorkStationDialog from "./CreateNewWorkStationDialog";
import UpdateWorkStationDialog from "./UpdateWorkStationDialog";

const DEFAULT_UPDATE_DIALOG_DATA = {
  open: false,
  workStation: null,
};
const WorkStations = ({ search, status }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [workStations, setWorkStations] = useState([]);
  const [createNewDialogOpen, setCreateNewDialogOpen] = useState(false);
  const [updateDialogData, setUpdateDialogData] = useState(
    DEFAULT_UPDATE_DIALOG_DATA,
  );

  const getWorkStations = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/work-stations`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status == 200 || response.status === 201) {
        setWorkStations(response.data.workStations);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWorkStations();
  }, []);

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">ID</TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Type</TableCell>
              <TableCell align="left">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {workStations.map((workStation, index) => {
              return (
                <TableRow
                  key={workStation.id}
                  onClick={() => {
                    console.log("SELECTED", workStation);
                    setUpdateDialogData({ open: true, workStation });
                  }}
                >
                  <TableCell align="left">{workStation.id}</TableCell>
                  <TableCell align="left">{workStation.name}</TableCell>
                  <TableCell align="left">
                    {workStation.workStationType ?? ""}
                  </TableCell>
                  <TableCell align="left">
                    {workStation.deletedAt ? "Inactive" : "Active"}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "50px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <Fab
          onClick={() => {
            setCreateNewDialogOpen(true);
          }}
          variant="extended"
          color="success"
        >
          <Add /> New
        </Fab>
      </div>
      <CreateNewWorkStationDialog
        open={createNewDialogOpen}
        onClose={() => {
          setCreateNewDialogOpen(false);
        }}
        onSuccess={() => {
          getWorkStations();
          setCreateNewDialogOpen(false);
          openSnackMessage("success", "Created");
        }}
      />
      <UpdateWorkStationDialog
        open={updateDialogData.open}
        workStation={updateDialogData.workStation}
        onClose={() => {
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
        }}
        onUpdated={() => {
          getWorkStations();
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
          openSnackMessage("success", "Updated");
        }}
        onDeleted={() => {
          getWorkStations();
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
          openSnackMessage("success", "Deleted");
        }}
        onActivated={() => {
          getWorkStations();
          setUpdateDialogData(DEFAULT_UPDATE_DIALOG_DATA);
          openSnackMessage("success", "Activated");
        }}
      />
    </Box>
  );
};
export default WorkStations;
